const workingAreaImages = {
  dataManagement: require('../assets/img/dataManagement.png'),
  complianceEstabCardIcon: require('../assets/img/complianceEstabCardIcon.png'),
  cockpit: require('../assets/img/cockpit.png'),
  internalControls: require('../assets/img/internalControls.png'),
  reporting: require('../assets/img/internalControls.png'),
  library: require('../assets/img/dataManagement.png'),
  auriscomLogo: require('../assets/img/Auriscom logo.png')
};

export default workingAreaImages;
